import { get } from '../../../utils/objectHelpers';
$ {
  const ratingName = get(input, 'rating.name');
  const ratingAccessibilityText = get(input, 'rating.accessibilityText');
}
<if(ratingName === "POSITIVE")>
    <svg class="imagePosition icon icon--feedback-positive"
        data-test-id=input.testId
        data-test-type="positive"
        viewBox="0 0 16 16"
        height="16"
        width="16"
        aria-label=(ratingAccessibilityText)
        role="img"
    >
    <circle cx="8" cy="8" r="8" fill="#05823F"/>
    <path d="M12.2857 7.28571H8.71429V3.71429C8.71429 3.3198 8.39449 3 8 3C7.60551 3 7.28571 3.3198 7.28571 3.71429V7.28571H3.71429C3.3198 7.28571 3 7.60551 3 8C3 8.39449 3.3198 8.71429 3.71429 8.71429H7.28571V12.2857C7.28571 12.6802 7.60551 13 8 13C8.39449 13 8.71429 12.6802 8.71429 12.2857V8.71429H12.2857C12.6802 8.71429 13 8.39449 13 8C13 7.60551 12.6802 7.28571 12.2857 7.28571Z" fill="white"/>
    </svg>
</if>
<else-if(ratingName === "NEUTRAL")>
    <svg class="imagePosition icon icon--feedback-neutral"
        data-test-id=input.testId
        data-test-type="neutral"
        viewBox="0 0 16 16"
        height="16"
        width="16"
        aria-label=(ratingAccessibilityText)
        role="img"
    >
        <circle cx="8" cy="8" r="8" fill="#6A6A6A"/>
        <path d="M11 5.49958C11 5.22343 10.7761 5.00001 10.5 5.00002L8.42858 5.0001C8.23825 5.00005 8.00106 5 8.00001 5C7.99998 5 7.99999 5 7.99995 5C7.76331 5 7.75264 5 7.57143 5.0001L5.5 5.00002C5.22386 5.00001 5 5.22341 5 5.49956C5 6.01718 5.00001 6.83975 5.00001 8.00005C5.00001 9.28144 4.99999 9.92657 5.00001 10.5001C5.00002 10.7762 5.22388 11 5.5 11H7.57143C7.62501 11 7.76331 11 8.00001 11C8.2367 11 8.33486 11 8.42858 11H10.5C10.7761 11 11 10.7766 11 10.5004C11 9.98285 11 9.16032 11 8.00005C11 6.83977 11 6.0172 11 5.49958Z" fill="white"/>
    </svg>
</else-if>
<else-if(ratingName === "NEGATIVE")>
    <svg class="imagePosition icon icon--feedback-negative"
        data-test-id=input.testId
        data-test-type="negative"
        viewBox="0 0 16 16"
        height="16"
        width="16"
        aria-label=(ratingAccessibilityText)
        role="img"
    >
    <circle cx="8" cy="8" r="8" fill="#E0103A"/>
    <path d="M12.2857 7.28577H8.71429C8.19218 7.28576 8.39449 7.28582 8 7.28582C7.60551 7.28582 7.63016 7.28577 7.28571 7.28577H3.71429C3.3198 7.28577 3 7.60556 3 8.00005C3 8.39454 3.3198 8.71434 3.71429 8.71434H7.28571C7.92047 8.71425 7.60551 8.71425 8 8.71425C8.39449 8.71425 8.39146 8.71434 8.71429 8.71434H12.2857C12.6802 8.71434 13 8.39454 13 8.00005C13 7.60556 12.6802 7.28577 12.2857 7.28577Z" fill="white"/>
    </svg>
</else-if>
